










































import Vue from 'vue';
import { stepV1, stepV2 } from '@/enums/donationStepOrder';
import { Donation } from '@/interfaces/donation/donation';
import { RequestSession } from '@/interfaces/requestSession';
import { isMemoryGift } from '@/classes/DonationType';
import { DonationGuideVersion } from '@/enums/donationGuideVersion';
import StepperFlowMixin from '@/mixins/donationStepperFlowMixin';

export default Vue.extend({
  mixins: [StepperFlowMixin],
  props: {
    showPreviousButton: Boolean,
    requestHasExternalAgent: Boolean,
    compact: Boolean,
  },
  computed: {
    steps(): typeof stepV1 | typeof stepV2 {
      return this.getDonationStepFlowVersion() == DonationGuideVersion.V1 ? stepV1 : stepV2;
    },
    donation(): Donation {
      return this.$store.state.donation;
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession;
    },
    currentStep() {
      return this.$store.state.currentStep;
    },
  },
  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        if (
          newVal === this.steps.INFORMATION &&
          (!isMemoryGift(this.donation.donationType.type) || this.requestHasExternalAgent)
        ) {
          this.handleStepRemoval(oldVal);
        } else {
          this.$emit('addStep', this.steps.INFORMATION);
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleStepRemoval(oldVal) {
      this.$emit('removeStep', this.steps.INFORMATION);
      if (oldVal === this.steps.INFORMATION + 1) {
        this.$emit('previousStep');
      } else {
        this.$emit('nextStep');
      }
    },
  },
});
